import React from 'react';

import {bootstrapzIndex} from 'js-libs/sweetcommons/styles';

import TabbedModal from 'app/components/general/TabbedModal';
import {gt} from 'app/utils/i18n';

import {CreateUserForm} from './CreateUserForm';

import {UserSerializedType} from 'sweet-types';

interface Props {
  name?: string;
  show: boolean;
  setShow: (show: boolean) => unknown;
  onCreateUser: (user: UserSerializedType) => Promise<unknown>;
}

export function CreateUserModal({name, show, setShow, onCreateUser}: Props) {
  return (
    <TabbedModal
      show={show}
      onCancel={() => setShow(false)}
      zIndex={bootstrapzIndex.popover}
      className="mw-100 px-4"
      tabs={[
        {
          eventKey: 'create-user',
          name: gt('Invite new member to account'),
          icon: 'fa fa-users',
          content: (
            <CreateUserForm
              isPopover={true}
              className="page-form"
              showTeams={false}
              hideGuestInvite={true}
              onCreateUser={onCreateUser}
              showCancelButton={true}
              onCancel={() => setShow(false)}
              name={name}
            />
          ),
        },
      ]}
    />
  );
}
